import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { parse, format } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function cln(...classes: (string | boolean)[]) {
  return classes.filter(Boolean).join(" ");
}

export const debounce = (func: (...args: any[]) => void, wait: number) => {
  let timeout: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

export function formatGatewayData(value: any, extra?: any): string {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value === "System.Int32[]" ||
    (typeof value === "string" && value.toLowerCase() === "null")
  ) {
    return "N/A";
  }
  if (extra) {
    return "$ " + value.toString();
  } else {
    return value.toString();
  }
}

export const formatLastPasswordChangeDate = (rawDate: string): string => {
  if (!rawDate) return "";

  try {
    const parsed = parse(rawDate, "MM/dd/yyyy HH:mm:ss XXX", new Date());
    const formatted = format(parsed, "d MMMM yyyy h:mm a");
    return `Last updated on ${formatted}`;
  } catch (error) {
    console.warn("Invalid date format:", rawDate, error);
    return "";
  }
};

export const formatDate = (input: string | undefined): string => {
  if (!input) return "";

  const parts = input.split("-");

  if (parts.length === 1) {
    return parts[0];
  } else if (parts.length === 2) {
    const [year, month] = parts.map(Number);
    const date = new Date(year, month - 1);
    return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  }

  return input;
};

export const getUserId = (userId: string | null) => {
  return userId ?? "defaultUser";
};
